export function setItem(key: string, value: string) {
  try {
    return localStorage.setItem(key, value);
  } catch {
    return null;
  }
}

export function getItem(key: string) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
